import React, { createContext, useContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

import { AUTH_STATUS, isTokenValid } from "../utils/authUtils";
import { logout } from "../services/auth.api";
import User from "../types/user";

type AuthContextType = {
  status: string;
  user: User | null;
  authSetToken: (token: string) => void;
  authRemoveToken: () => void;
};

const AuthContext = createContext<AuthContextType>(null!);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const { LOADING, AUTHENTICATED, UNAUTHENTICATED } = AUTH_STATUS;
  const [token, setToken] = useState<string | null>(
    () => localStorage.getItem("access_token")
  );
  const [status, setStatus] = useState<string>(LOADING);
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
     if (!token) {
        setStatus(UNAUTHENTICATED);
        setUser(null);
        return; 
      }

      if (!isTokenValid(token)) {
        logout();
        return;
      }

      const decoded = jwtDecode<User>(token);
      setUser(decoded);
      setStatus(AUTHENTICATED);
  }, [token]);

  const authSetToken = (newToken: string) => {
    localStorage.setItem("access_token", newToken);
    setToken(newToken);   
  }

  const authRemoveToken = () => {
    localStorage.removeItem("access_token");
    setToken(null);      
  };

  return (
    <AuthContext.Provider value={{ status, user, authSetToken, authRemoveToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export default function useAuth() {
  return useContext(AuthContext);
}